import { render, staticRenderFns } from "./createPrize.vue?vue&type=template&id=49715396&scoped=true"
import script from "./createPrize.vue?vue&type=script&lang=js"
export * from "./createPrize.vue?vue&type=script&lang=js"
import style0 from "./createPrize.vue?vue&type=style&index=0&id=49715396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49715396",
  null
  
)

export default component.exports